import { render, staticRenderFns } from "./DropZoneFileUploader.vue?vue&type=template&id=70a9eb2d"
import script from "./DropZoneFileUploader.vue?vue&type=script&lang=js"
export * from "./DropZoneFileUploader.vue?vue&type=script&lang=js"
import style0 from "./DropZoneFileUploader.vue?vue&type=style&index=0&id=70a9eb2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports